import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthSessionService } from '../../auth-session.service';
import { RouterLink, RouterLinkActive } from '@angular/router'; 

@Component({
  imports: [NgOptimizedImage, RouterLink, RouterLinkActive],
  selector: 'app-banner',
  styleUrl: './banner.scss',
  templateUrl: './banner.html',
})
export class Banner {
  private readonly router = inject(Router);
  private readonly authSession = inject(AuthSessionService);

  /** Logged-in users have a pax version; used to show the nav and the logout link. */
  readonly version = this.authSession.paxVersion;

  /** Current path (no query/fragment). A signal, because the app is zoneless and router.url isn't reactive. */
  private readonly currentPath = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.split(/[?#]/)[0]),
    ),
    { initialValue: this.router.url.split(/[?#]/)[0] },
  );

  /** Pages that are part of the normal navigation flow. */
  private readonly navigationPages = [
    '/home',
    '/destination',
    '/agenda',
    '/attire',
    '/activities',
    '/dining',
    '/travelGuide',
    '/faqs',
  ];

  /** The nav bar only shows when logged in, and only on the content pages (never on /login). */
  readonly showNav = computed(() => !!this.version() && this.navigationPages.includes(this.currentPath()));

  logout(): void {
    this.authSession.clear();
    void this.router.navigateByUrl('/login');
  }
}
